export const version = "random/5.6.0";
//# sourceMappingURL=_version.js.map